module.exports = __webpack_public_path__ + "static/zariel-a525c034c4ba7952e9d06ebf25018f5b.jpeg";